module.exports = __webpack_public_path__ + "static/media/img_1.a006de5a.png";